module.exports = __webpack_public_path__ + "static/de923233ca4093be704ee11047ec9ca49e718faabadfb18b1f5ebab368d874e3-e950055f4e73ede9a489c9d89b16535d.jpeg";